<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="getFilteredInventoryRecordsCorrections"
    sort-by="created"
    :sort-desc="true"
    :items-per-page="getFilteredInventoryRecordsCorrections.length + 1"
    hide-default-footer
    :group-by="groupBy ? 'fk_product' : []"
    :group-desc="true"
    :mobile-breakpoint="0"
    dense
  >
    <template v-slot:group.header="{ group }">
      <td></td>
      <td>{{ getQuantityMean(group) }}</td>
      <td>
        {{ getPercentMean(group) }}
        <span class="caption">({{ getPercentMeanWithoutZero(group) }})</span>
      </td>
      <td></td>
      <td></td>
    </template>
    <template v-slot:item.created="{ item }">
      <span class="caption">{{ item.created | denseDateHourFormat }}</span>
    </template>
    <template v-slot:item.comments="{ item }">
      <span class="caption">{{ item.comments }}</span>
      <Prompt
        :activator-icon="item.comments !== null ? 'fa-edit' : 'fa-plus'"
        activator-size="x-small"
        activator-icon-size="small"
        inputText="Commentaire"
        errorMessage="Un commentaire est requis"
        text
        color=""
        @submit="v => setCorrectionComment(item, v)"
      ></Prompt>
    </template>
    <template v-slot:item.quantity="{ item }">
      <span class="caption">{{ Number(item.quantity) | round2 }}</span>
      <span class="overline ml-1">{{ getUnit(item) }}</span>
    </template>
    <template v-slot:item.percent="{ item }">
      <span class="caption" v-if="item.percent !== null"
        >{{ Number(item.percent * 100) | round2 }} %</span
      >
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" dense no-gutters>
        <RecordCorrectionOmitEdit
          :item="item"
          @update="getData"
        ></RecordCorrectionOmitEdit>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import RecordCorrectionOmitEdit from "./RecordCorrectionOmitEdit";
import { mapGetters } from "vuex";
import { api } from "@/api";
import moment from "moment";
import { round10 } from "round10";
export default {
  name: "RecordsCorrectionsGrid",
  components: {
    RecordCorrectionOmitEdit
  },
  props: {
    take: {
      required: true
    },
    productFilter: {
      required: true
    },
    start: {
      required: true
    },
    end: {
      required: true
    },
    groupBy: {
      required: true
    }
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters(["getProducts"]),
    getFilteredInventoryRecordsCorrections() {
      return this.productFilter
        ? this.data.filter(x => x.fk_product === this.productFilter)
        : this.data;
    }
  },
  data() {
    return {
      data: [],
      loading: false,
      headers: [
        { value: "created", text: "Date", sortable: false, class: "px-1" },
        {
          value: "quantity",
          text: "Variation (qté)",
          sortable: false,
          class: "px-1"
        },
        {
          value: "percent",
          text: "Variation (%)",
          sortable: false,
          class: "px-1"
        },
        {
          value: "comments",
          text: "Commentaire",
          sortable: false,
          class: "px-1"
        },
        { value: "actions" }
      ]
    };
  },
  methods: {
    async getData() {
      if (this.take !== null || this.start !== null) {
        try {
          this.loading = true;
          this.data = await api.getInventoryRecordsCorrections({
            take: this.take,
            product: this.productFilter,
            start:
              this.start != null
                ? moment(this.start)
                    .hours(0)
                    .minutes(0)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.start,
            end:
              this.end != null
                ? moment(this.end)
                    .hours(23)
                    .minutes(59)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.end
          });
        } finally {
          this.loading = false;
        }
      }
    },
    async setCorrectionComment(item, value) {
      if (value) {
        item.comments = value;
        const data = {
          id: item.id,
          comments: value
        };
        await api.patchInventoryRecordsCorrections(item.id, data);
      }
    },
    getProductName(item) {
      return this.getProducts.find(x => x.id === item.fk_product)
        ? this.getProducts.find(x => x.id === item.fk_product).nom
        : "";
    },
    getProductNameById(id) {
      return this.getProducts.find(x => x.id == id)
        ? this.getProducts.find(x => x.id == id).nom
        : "";
    },
    getUnit(item) {
      return this.getProducts.find(x => x.id == item.fk_product)
        ? this.getProducts.find(x => x.id == item.fk_product).data
          ? this.getProducts.find(x => x.id == item.fk_product).data
              .unite_mesure_inventory
          : ""
        : "";
    },
    getQuantityMean(id) {
      const d = this.data.filter(x => x.fk_product == id);
      if (d.length > 0) {
        return `${round10(
          d.map(x => +x.quantity).reduce((a, b) => a + b, 0) / d.length,
          -2
        )} ${this.getUnit({ fk_product: id })}`;
      } else {
        return "";
      }
    },
    getPercentMean(id) {
      const d = this.data.filter(x => x.fk_product == id);
      if (d.length > 0) {
        return `${round10(
          d.map(x => +x.percent * 100).reduce((a, b) => a + b, 0) / d.length,
          -2
        )} %`;
      } else {
        return "";
      }
    },
    getPercentMeanWithoutZero(id) {
      const d = this.data.filter(x => x.fk_product == id && x.percent !== 0);
      if (d.length > 0) {
        return `${round10(
          d.map(x => +x.percent * 100).reduce((a, b) => a + b, 0) / d.length,
          -2
        )} %`;
      } else {
        return "";
      }
    }
  },
  watch: {
    take(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    productFilter(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    start(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    end(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    }
  }
};
</script>

<style></style>
